// extracted by mini-css-extract-plugin
export var alertIcon = "_op-0";